import { render, staticRenderFns } from "./IconSpeedioWtf.vue?vue&type=template&id=6b91fc9e&"
import script from "./IconSpeedioWtf.vue?vue&type=script&lang=ts&"
export * from "./IconSpeedioWtf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports